function convertKelvinToCelsius(num) {
  let eq =
    "Converting " + num + "° kelvin to celsius: \n" + num + " - 273.15 = ";
  let rep = num - 273.15;
  return eq + rep.toFixed(3);
}

function convertKelvinToFahrenheit(num) {
  let eq =
    "Converting " +
    num +
    "° kelvin to fahrenheit: \n" +
    "((" +
    num +
    " * 9) / 5) - 459.67 = ";
  let rep = (num * 9) / 5 - 459.67;
  return eq + rep.toFixed(3);
}

function convertKelvinToRankine(num) {
  let eq =
    "Converting " +
    num +
    "° kelvin to rankine: \n" +
    "(" +
    num +
    " * 9) / 5 = ";
  let rep = (num * 9) / 5;
  return eq + rep.toFixed(2);
}

function convertKelvinToDelisle(num) {
  let eq =
    "Converting " +
    num +
    "° kelvin to delisle: \n" +
    "((373.15 - " +
    num +
    ") * 3) / 2 = ";
  let rep = ((373.15 - num) * 3) / 2;
  return eq + rep.toFixed(3);
}

function convertKelvinToNewton(num) {
  let eq =
    "Converting " +
    num +
    "° kelvin to newton: \n" +
    "((" +
    num +
    " - 273.15) * 33) / 100 = ";
  let rep = ((num - 273.15) * 33) / 100;
  return eq + rep.toFixed(3);
}

function convertKelvinToRéaumur(num) {
  let eq =
    "Converting " +
    num +
    "° kelvin to réaumur: \n" +
    "((" +
    num +
    " - 273.15 )* 4) / 5 = ";
  let rep = ((num - 273.15) * 4) / 5;
  return eq + rep.toFixed(3);
}

function convertKelvinToRømer(num) {
  let eq =
    "Converting " +
    num +
    "° Kelvin to rømer: \n" +
    "(((" +
    num +
    " - 273.15) * 21) / 40) + 7.5 = ";
  let rep = ((num - 273.15) * 21) / 40 + 7.5;
  return eq + rep.toFixed(3);
}

export {
  convertKelvinToRømer,
  convertKelvinToRéaumur,
  convertKelvinToNewton,
  convertKelvinToDelisle,
  convertKelvinToRankine,
  convertKelvinToFahrenheit,
  convertKelvinToCelsius
};
